import { render, staticRenderFns } from "./comment_form.vue?vue&type=template&id=ee5934be&scoped=true&"
import script from "./comment_form.vue?vue&type=script&lang=js&"
export * from "./comment_form.vue?vue&type=script&lang=js&"
import style0 from "./comment_form.vue?vue&type=style&index=0&id=ee5934be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5934be",
  null
  
)

export default component.exports